import { useState, useEffect, useCallback } from "react";
import {useSelector} from 'react-redux';
import useDebounce from "../../../utils/UseDebounce";
import 'react-tippy/dist/tippy.css';
import {Tooltip} from 'react-tippy';
import { getFreeTextResults } from './ResultsCreator';
import DetailedResultsTable from "./DetailedResultsTable";

function FreeTextResults() {
	const {resultsCurrentElement, unMappedUserResults} = useSelector(state => state.user);
	const [mappedResults, setMappedResults] = useState([])
	const [calculatedResults, setCalculatedResults] = useState([])
	const [calculatedGeneralResults, setCalculatedGeneralResults] = useState([])
	const [calculatedByScoreGeneralResults, setCalculatedByScoreGeneralResults] = useState([])
	const [searchTerm, setSearchTerm] = useState('')
	const throttledSearchTerm = useDebounce(searchTerm, 600);
	const [sorting, setSorting] = useState('popularity');
	const [onlyValidAnswers, setOnlyValidAnswers] = useState(false);
	const [loading, setLoading] = useState(false);
	
	const mapResults = useCallback(async () => {
		setLoading(true)
		const results = await getFreeTextResults(unMappedUserResults, resultsCurrentElement, onlyValidAnswers)
		setMappedResults(results[0]);
		setLoading(false)
	}, [onlyValidAnswers, unMappedUserResults, resultsCurrentElement])
	const calculateMappedResults = useCallback(() => {
		let o = [];
		if(throttledSearchTerm){
			o = mappedResults.filter((row) => {
				return row.find(cell => {
					return cell?.toString().toLowerCase().search(throttledSearchTerm.toLowerCase()) >= 0
				});
			})
		}else{
			o = mappedResults
		}
		o.sort((a, b) => {
			let a1 = a[a.length-1]
			let b1 = b[b.length - 1]
			return new Date(b1) - new Date(a1);
		})
		setCalculatedResults(o)
		
	}, [mappedResults, resultsCurrentElement, sorting, throttledSearchTerm])

	useEffect(() => {
		calculateMappedResults();
	}, [mappedResults, throttledSearchTerm, calculateMappedResults])
	useEffect(() => {
		if(resultsCurrentElement && unMappedUserResults) mapResults();
	}, [resultsCurrentElement, unMappedUserResults, mapResults])
	return (
		<div className="numericPrediction__results">
			<div className="mtop--10">
				<div className="mtop--20 table__wrapper">
					<DetailedResultsTable total={calculatedResults.length} header={resultsCurrentElement.tableHeader} rows={calculatedResults} />
				</div>
			</div>
		</div>
	);
}

export default FreeTextResults;
